<template>
  <CCard class="metric-history-table">
    <CCardBody class="p-0">
      <div class="metric-history-table__header">
        <div>Datum</div>
        <div>{{ valueTitle }}</div>
        <div>Promjena</div>
      </div>

      <div v-for="(row, index) in rows" :key="row.key" class="metric-history-table__group">
        <button
          type="button"
          class="metric-history-table__row"
          :class="{ 'metric-history-table__row--striped': index % 2 === 0 }"
          @click="toggle(row)"
        >
          <div class="metric-history-table__title">{{ row.title }}</div>
          <div class="metric-history-table__value">{{ row.value !== null ? `${row.value} ${unit}` : "-" }}</div>
          <div class="metric-history-table__difference">
            <span v-if="row.difference !== null" :class="differenceClass(row.difference)">
              {{ row.formattedDifference }} {{ unit }}
            </span>
            <span v-else class="metric-history-table__difference--empty">-</span>
            <CIcon
              :name="row.isExpanded ? 'cil-chevron-top' : 'cil-chevron-bottom'"
              class="metric-history-table__chevron"
            />
          </div>
        </button>

        <CCollapse :show="row.isExpanded">
          <div class="metric-history-table__details">
            <div v-for="item in row.items" :key="item.date" class="metric-history-table__detail-row">
              <div>{{ item.date }}</div>
              <div>{{ item.value !== null ? `${item.value} ${unit}` : "-" }}</div>
              <div></div>
            </div>
          </div>
        </CCollapse>
      </div>
    </CCardBody>
  </CCard>
</template>

<script>
import { buildMetricHistoryRows, getMetricDifferenceClass } from "../metricHistory";

export default {
  props: {
    entries: {
      type: Array,
      default: () => [],
    },
    valueTitle: {
      type: String,
      required: true,
    },
    unit: {
      type: String,
      required: true,
    },
    decimals: {
      type: Number,
      default: 0,
    },
    increaseIsGood: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    rows() {
      return buildMetricHistoryRows(this.entries, this.decimals);
    },
  },
  methods: {
    toggle(row) {
      row.isExpanded = !row.isExpanded;
      this.$forceUpdate();
    },
    differenceClass(difference) {
      return getMetricDifferenceClass(difference, this.increaseIsGood);
    },
  },
};
</script>

<style scoped>
.metric-history-table {
  border: 1px solid #e5e7eb;
  border-radius: 16px;
  box-shadow: none;
  overflow: hidden;
}

.metric-history-table__header,
.metric-history-table__row,
.metric-history-table__detail-row {
  display: grid;
  grid-template-columns: minmax(0, 1.5fr) minmax(90px, 0.8fr) minmax(110px, 0.9fr);
  gap: 1rem;
  align-items: center;
}

.metric-history-table__header {
  padding: 1rem 1.5rem;
  background: #f8fafc;
  border-bottom: 1px solid #e5e7eb;
  color: #64748b;
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

button.metric-history-table__row {
  width: 100%;
  padding: 1rem 1.5rem;
  border: 0 !important;
  border-bottom: 1px solid #eef2f7 !important;
  border-radius: 0 !important;
  background: #ffffff !important;
  color: #0f172a !important;
  text-align: left;
  min-height: 0 !important;
  box-shadow: none !important;
  transform: none !important;
  justify-content: stretch;
}

button.metric-history-table__row--striped {
  background: #fcfdfd !important;
}

button.metric-history-table__row:hover,
button.metric-history-table__row:focus {
  background: #f8fafc !important;
  color: #0f172a !important;
  box-shadow: none !important;
  transform: none !important;
}

.metric-history-table__title {
  font-weight: 600;
}

.metric-history-table__value,
.metric-history-table__difference--good,
.metric-history-table__difference--bad {
  font-weight: 700;
}

.metric-history-table__difference {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  min-width: 0;
}

.metric-history-table__difference--good {
  color: #059669;
}

.metric-history-table__difference--bad {
  color: #dc2626;
}

.metric-history-table__difference--empty,
.metric-history-table__chevron {
  color: #94a3b8;
}

.metric-history-table__chevron {
  flex-shrink: 0;
}

.metric-history-table__details {
  padding: 0 1.5rem 0.75rem;
  background: #f8fafc;
}

.metric-history-table__detail-row {
  padding: 0.75rem 0;
  border-top: 1px solid #e5e7eb;
  color: #475569;
  font-size: 0.95rem;
}

@media (max-width: 767px) {
  .metric-history-table__header,
  .metric-history-table__row,
  .metric-history-table__detail-row {
    grid-template-columns: minmax(0, 1.2fr) minmax(72px, 0.7fr) minmax(96px, 0.8fr);
    gap: 0.75rem;
  }

  .metric-history-table__header,
  .metric-history-table__row,
  .metric-history-table__details {
    padding-left: 1rem;
    padding-right: 1rem;
  }
}
</style>
